export const convertToNumber = (v: string | number | Date) =>
  typeof v === "string"
    ? isNaN(parseFloat(v))
      ? parseFloat(v)
      : new Date(v).valueOf()
    : typeof v === "number"
    ? v
    : new Date(v).valueOf();
